import React from 'react';
import { Group } from '@landr/maestro';
import ChooseYourPlan from './components/ChooseYourPlan/ChooseYourPlan';
import SaleBanner from './components/SaleBanner/SaleBanner';
import FrequencySwitch from './components/FrequencySwitch/FrequencySwitch';
import SamplePlan from './components/SamplePlan/SamplePlan';
import StudioPlan from './components/StudioPlan/StudioPlan';
import BuyPlanButton from './components/BuyPlanButton/BuyPlanButton';
import AddedToYourStudioPlan from './components/AddedToYourStudioPlan/AddedToYourStudioPlan';
import * as Styled from './styled';
import UpsellActionsProvider from './context/UpsellActionsContext';

const UpsellActions = ({ creditsNeeded }: { creditsNeeded?: number }) => (
    <UpsellActionsProvider creditsNeeded={creditsNeeded}>
        <Styled.Wrapper>
            <Styled.Header />
            <Styled.Content>
                <ChooseYourPlan />
                <SaleBanner />
                <Group direction="vertical" alignItems="stretch">
                    <FrequencySwitch />
                    <SamplePlan />
                    <StudioPlan />
                    <Group.Item>
                        <BuyPlanButton />
                    </Group.Item>
                    <AddedToYourStudioPlan />
                </Group>
            </Styled.Content>
        </Styled.Wrapper>
    </UpsellActionsProvider>
);

export default UpsellActions;
